module.exports = __webpack_public_path__ + "static/img/bg-id.17161434.webp";